<template>
  <div class="phone" @touchmove.prevent>
    <div class="nav">
      <div class="logo">
        <img src="@/assets/phone/phone-logo.png">
      </div>
      <div @click="onHide" class="fork">
        <span class="iconfont icon-chahao"></span>
      </div>
    </div>
    <div class="list">
      <ul>
        <li @click="onskip(item.url)" v-for="(item, index) in list" :key="index">{{item.name}}</li>
        <li @click="onChinese">中文</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "phoneNav.vue",

  data() {
    return {
      list: [{
        url: '/',
        name: 'Home'
      }, {
        url: '/apparel',
        name: 'Wearable device'
      }, {
        url: '/interaction',
        name: 'Interactive control'
      }, {
        url: '/robot',
        name: 'Empowering AI'
      }, {
        url: 'https://www.x-bci.com/',
        name: 'X-BCI'
      }, {
        url: '/conference',
        name: 'BCI Developers Conference'
      }, {
        url: '/relation',
        name: 'Contact us'
      },]
    }
  },

  methods: {
    onHide() {
      this.$emit("onHide")
    },

    onskip(url) {
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        this.$router.push(url)
      }
      this.$emit("onHide")
    },

    onChinese() {
      window.location.href = "/"
    }
  },
}
</script>

<style scoped>
.phone {
  background-image: url("../../assets/phone/Group770.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  height: 0.43rem;
  line-height: 0.43rem;
  color: #FFFFFF;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
  cursor: pointer;
}

.list {
  padding-left: 0.9rem;
  padding-top: 0.7rem;
  padding-bottom: 4.7rem;
}

.list ul li {
  margin-top: 1rem;
  list-style: none;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.32rem;
  line-height: 0.42rem;
  color: #FFFFFF;
  cursor: pointer;
  letter-spacing: 0.01rem;
}
</style>
